import { render, staticRenderFns } from "./BorrowVideoFilterBar.vue?vue&type=template&id=be90d5d0&"
import script from "./BorrowVideoFilterBar.vue?vue&type=script&lang=js&"
export * from "./BorrowVideoFilterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports